// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"27d7ce6a","453":"5639d347","455":"16e1c1f9"}[chunkId] + ".chunk.js";
};